<script setup lang="ts">
import type { Component } from 'vue'

import { TrashIcon, XMarkIcon } from '@heroicons/vue/24/outline'

import { translationFunctionCommon } from '@/utilities/translations'

import ButtonTertiary from '../buttons/ButtonTertiary.vue'

defineProps<{ open: boolean; showDelete?: boolean; title: string }>()
const emit = defineEmits<{ onClose: []; onDelete: [] }>()

defineSlots<{ default: Component }>()

const tfCommon = translationFunctionCommon()

const onClose = (event: Event): void => {
  // Prevent the click if the user is interacting with an alert
  if (event.target instanceof HTMLElement && event.target.closest('.alert-message-overlay')) return

  emit('onClose')
}

const onDelete = (): void => {
  emit('onDelete')
}
</script>

<template>
  <Teleport v-if="open" to="body">
    <div class="fixed inset-0 z-[10000] overflow-y-auto bg-black-950 bg-opacity-20">
      <div class="flex min-h-full items-center justify-center p-4">
        <div
          v-click-outside="onClose"
          class="w-full min-w-[40%] max-w-[90%] rounded-lg bg-white p-8 pt-5 shadow-lg lg:max-w-[45rem]"
        >
          <div class="flex items-center justify-between">
            <h2 class="text-lg font-semibold leading-none">{{ title }}</h2>
            <div class="flex items-center gap-2">
              <template v-if="showDelete">
                <ButtonTertiary :label="tfCommon('button.delete')" @click="onDelete">
                  <TrashIcon />
                </ButtonTertiary>
                <div class="h-6 w-px bg-black-200" />
              </template>

              <XMarkIcon
                class="h-5 w-5 cursor-pointer text-black-400 hover:text-black-500"
                @click="onClose"
              />
            </div>
          </div>
          <slot></slot>
        </div>
      </div>
    </div>
  </Teleport>
</template>
